/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { floatingPanelBorderProps } from "./floatingPanelUtils";

export interface IFloatingPanelBorderProps {
	clone?: boolean;
}

export const FloatingPanelBorder: React.FC<IFloatingPanelBorderProps> = ({ children, clone }) => {
	if (clone) {
		const child = React.Children.only(children);

		if (React.isValidElement(child)) {
			return React.cloneElement(child, floatingPanelBorderProps);
		}
	}

	return <div {...floatingPanelBorderProps}>{children}</div>;
};
